/**
 * Agent Portal - Calcolatore Guadagni.
 * Wrapper che rende il componente pubblico ProfitCalculator all'interno del
 * layout agente senza duplicare la logica.
 */
import React from 'react';
import AgentLayout from './AgentLayout';
import ProfitCalculator from '../ProfitCalculator';

const AgentProfitCalculator = () => {
  return (
    <AgentLayout>
      <div data-testid="agent-strumenti-calcolatore">
        <ProfitCalculator hideChrome />
      </div>
    </AgentLayout>
  );
};

export default AgentProfitCalculator;
